import React, { Component } from 'react';
import { connect } from 'react-redux';

class Loader extends Component {

    render(){
        let loader = this.props.customLoader ? this.props.customLoader : this.props.showLoader
        let display = loader ? 'block' : 'none';
        return (
            loader &&
            <div className="overlay overlay-light" style={{ display: display }}>
                <div className="sk-fading-circle">
                  <div className="sk-circle1 sk-circle"></div>
                  <div className="sk-circle2 sk-circle"></div>
                  <div className="sk-circle3 sk-circle"></div>
                  <div className="sk-circle4 sk-circle"></div>
                  <div className="sk-circle5 sk-circle"></div>
                  <div className="sk-circle6 sk-circle"></div>
                  <div className="sk-circle7 sk-circle"></div>
                  <div className="sk-circle8 sk-circle"></div>
                  <div className="sk-circle9 sk-circle"></div>
                  <div className="sk-circle10 sk-circle"></div>
                  <div className="sk-circle11 sk-circle"></div>
                  <div className="sk-circle12 sk-circle"></div>
                </div>
                <div className="spinner-message">お待ちください...</div>
          </div>
        );
    }
};

const mapStateToProps = (state) => { 
    return{
        showLoader: state.auth.showLoader,
    }
    
};

export default connect(mapStateToProps)(Loader);

